import React, { Component } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styles from "../styles/scss/components/heroSema.module.scss"
import { buildURL } from "react-imgix"
import Title from "./title"

class HeroSema extends Component {
    constructor(props) {
        super()
    }
    static defaultProps = {}

    render() {
        const { images, title, onClick } = this.props

        const getTitleParts = (title, part) => {
            return title.split("\n")[part]
        }

        const divStyles = {
            mobile: {
                background: "url(" + buildURL(images[0].url, {}) + ")",
            },
            desktop: {
                background: "url(" + buildURL(images[1].url, {}) + ")",
            },
        }
        return (
            <div className={styles.heroDesktop} style={divStyles.desktop}>
                <div className={styles.heroMobile} style={divStyles.mobile}>
                    <div className={styles.heroContent2023}>
                        <div className={styles.heroSubContent}>
                            <div>
                                <Title className={styles.heroSemaTitle2023}>
                                    {getTitleParts(title, 0)}
                                </Title>
                                <Title className={styles.heroSemaSubTitle2023}>
                                    {getTitleParts(title, 1)}
                                </Title>
                                <Link
                                    className={styles.heroSemaButtonContainer}
                                    to="/custombuild/1951Chevrolet3100/"
                                >
                                    <p className={styles.redButton}>SEE 2021 BUILD</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

HeroSema.propTypes = {
    images: PropTypes.array.isRequired,
    title: PropTypes.string,
    goTo: PropTypes.string,
}

export default HeroSema
